import useSWR from 'swr'
import { encodeUrlParams, get } from 'api/api'
import { Vehicle } from './types'

interface VehiclesParams {
  startDate?: string
  endDate?: string
}

export const useVehicles = (params?: VehiclesParams) => {
  const url = params ? encodeUrlParams('/vehicles', params) : '/vehicles'
  return useSWR<Vehicle[]>(url, get)
}

export const useVehicle = (vehicleId: string | undefined) => {
  const res = useVehicles()
  const data = res.data?.find((vehicle) => vehicle.id === vehicleId)
  return { ...res, data }
}
